import { initializeMobile, InitializeTicket, initializeSession } from "../../../redux/action"
import { Switch, Badge, Affix, Button, Empty, Spin } from "antd"
import { useIsAuthenticated, useMsal } from "@azure/msal-react"
import React, { Fragment, useEffect, useState } from "react"
import { Loading } from "notiflix"
import { connect } from "react-redux"

import Navbar from "../../../atoms/navbar"
import Header from "../../../utils/header_osticket"
import ImportantInfo from "../../../atoms/important-updates"

import { loginRequest } from "../../../config/api.config"
import { callMsGraph } from "../../../utils/graph"
import { useNavigate } from "react-router"
import { useLocation } from "react-router-dom"
import Footer from "../../../atoms/footer"
import API from "../../../services"
import "./styles.css"
import { requestToken } from "../../../auth/AuthServices"

function HistoryTicket(props) {
  const navigate = useNavigate()
  const location = useLocation()
  const base = location.pathname.startsWith("/saphelp") ? "/saphelp" : "/help"
  const [ticketList, setTicketList] = useState([])
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState(true)

  const isAuthenticated = useIsAuthenticated()
  const { instance, accounts } = useMsal()

  const isFullfilled = props.inititialSession?.email && props.inititialSession?.fullname && props.inititialSession?.phonenumber

  function getAllTicket(mail) {
    API.DetailTicket(Header(), mail)
      .then(res => {
        let tickets = Array.isArray(res?.tickets) ? res.tickets : []

        if (base === "/saphelp") {
          tickets = tickets.filter(ticket => {
            const topic = ticket?.help_topic
            if (!topic || typeof topic !== "string") return false
            return topic.split("-")[0].trim() === "SAP"
          })
        }

        tickets.sort(function (a, b) {
          return new Date(b.create_timestamp) - new Date(a.create_timestamp)
        })

        setTicketList(tickets)
        setLoading(false)
      })
      .catch(err => {
        setLoading(false)
      })
  }

  function handleLogin(instance) {
    instance
      .loginRedirect(loginRequest)
      .then(res => {})
      .catch(e => {
        console.error(e)
      })
  }

  function onChangeSwitch(checked) {
    if (!checked) {
      setFilter(false)
    } else {
      setFilter(true)
    }
  }

  function goDetail(id) {
    navigate(`${base}/detail/${id}`)
  }

  useEffect(() => {
    const fetchData = async () => {
      let email = props.inititialSession?.email
      let fullname = props.inititialSession?.fullname
      let phonenumber = props.inititialSession?.phone_number

      if (!email) {
        const stored = localStorage.getItem("session_signin")
        if (stored) {
          const session = JSON.parse(stored)
          email = session.email
          fullname = session.fullname
          phonenumber = session.phone_number || session.phonenumber
          props.setInitializeSession(session)
        }
      }

      try {
        const accessToken = await requestToken(false)
        if (accessToken) {
          const userInfo = await callMsGraph(accessToken)

          email = userInfo?.mail || userInfo?.userPrincipalName || email
          fullname = userInfo?.displayName || fullname
          phonenumber = userInfo?.mobilePhone || phonenumber

          // Save Session
          props?.setInitializeTicket(null, {
            email,
            fullname,
            phonenumber,
          })
        }
      } catch (error) {
        console.error("Error fetching data:", error)
      }

      if (email) {
        getAllTicket(email)
      } else {
        Loading.remove()
        setLoading(false)
      }
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, props.inititialSession])

  return (
    <Fragment>
      <Navbar
        title="Ticket History"
        // if mobile back button hide, because show in mobile
        back={true}
        subtitle="Help Center"
        navigate="/"
      />
      <div className="container white-back-cr" style={{ minHeight: 500 }}>
        <ImportantInfo />
        <div className="container mt-3 p-3">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <Affix offsetTop={10}>
                <div className="col-md-6 d-flex justify-content-start">
                  <Button
                    type="primary"
                    onClick={() => {
                      if (isFullfilled) {
                        navigate(`${base}/create-ticket-detail`)
                      } else {
                        navigate(`${base}/create-ticket`)
                      }
                    }}
                    size="middle"
                  >
                    Create Ticket
                  </Button>
                </div>
              </Affix>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col" />
            <div className="col-md-6 d-flex justify-content-end">
              <label style={{ marginRight: 10 }}>Filter</label>
              <Switch size="default" className="ml-2" checkedChildren="Open" unCheckedChildren="Finished" defaultChecked onChange={onChangeSwitch} />
            </div>
          </div>

          <div className="row">
            <div className="col-md-10 offset-md-1">
              {ticketList.length > 0 ? (
                ticketList.map(function (data, index) {
                  if (filter) {
                    if (data.ticket_status === "Open") {
                      return (
                        <Fragment key={index}>
                          <Badge.Ribbon color="blue" text={data.ticket_status}>
                            <div className="list-style p-3 px-4 mb-3" onClick={() => goDetail(data.ticket_number)}>
                              <div className="title mb-4">
                                <p className="fs-7 mb-0">{data.subject}</p>
                              </div>
                              <div className="hour d-flex justify-content-between m-1">
                                <p className="fs-7" style={{ color: "#B7B7B7" }}>
                                  {data.create_timestamp}
                                </p>
                              </div>
                            </div>
                          </Badge.Ribbon>
                        </Fragment>
                      )
                    }
                  } else {
                    if (data.ticket_status === "Closed" || data.ticket_status === "Resolved") {
                      return (
                        <Fragment key={index}>
                          <div className="list-style p-3 px-4 mb-3" onClick={() => goDetail(data.ticket_number)}>
                            <div className="title mb-4">
                              <p className="fs-7 mb-0">{data.subject}</p>
                            </div>
                            <div className="hour d-flex justify-content-between m-1">
                              <p className="fs-7" style={{ color: "#B7B7B7" }}>
                                {data.create_timestamp}
                              </p>
                              <p className="fs-7 fw-bold" style={data.ticket_status === "Open" ? { color: "#FF6961" } : { color: "#089D20" }}>
                                {data.ticket_status}
                              </p>
                            </div>
                          </div>
                        </Fragment>
                      )
                    }
                  }
                })
              ) : (
                <Empty className="mt-5" />
              )}
              {ticketList.length > 0 && (
                <div className="fs-6 text-center mt-5" style={{ color: "#B7B7B7" }}>
                  No more data
                </div>
              )}
              {loading && (
                <div className="fs-6 text-center mt-5" style={{ color: "#B7B7B7" }}>
                  <Spin size="large" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </Fragment>
  )
}

const reduxState = state => ({
  initializeTicket: state.initializeTicket,
  initializeMobile: state.initializeMobile,
  inititialSession: state.session,
})

const reduxDispatch = dispatch => ({
  setInitializeTicket: (navigate, data) => dispatch(InitializeTicket(navigate, data)),
  setInitializeSession: data => dispatch(initializeSession(data)),
  setInitializeMobile: data => dispatch(initializeMobile(data)),
})

export default connect(reduxState, reduxDispatch)(HistoryTicket)
